import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { createUseThemedStyles } from '@/hooks';

const useStyles = createUseThemedStyles((theme) => ({
	menuButton: {
		width: 44,
		height: 44,
		padding: 0,
		alignItems: 'center',
		justifyContent: 'center',
		'& span': {
			width: 30,
			height: 4,
			flexShrink: 0,
			borderRadius: 1,
			position: 'relative',
			backgroundColor: theme.colors.white,
			transition: 'background-color 200ms',
			'&:before, &:after': {
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				content: '""',
				borderRadius: 1,
				position: 'absolute',
				transition: 'transform 200ms',
				backgroundColor: theme.colors.white,
			},
			'&:before': {
				transform: 'translateY(-8px)',
			},
			'&:after': {
				transform: 'translateY(8px)',
			},
		},
		'&.active span': {
			backgroundColor: 'transparent',
			'&:before': {
				transform: 'translateY(0) rotate(45deg)',
			},
			'&:after': {
				transform: 'translateY(0) rotate(-45deg)',
			},
		},
	},
}));

interface HeaderMenuButtonProps {
	open: boolean;
	onClick(open: boolean): void;
}

export const HeaderMenuButton = ({ open, onClick }: HeaderMenuButtonProps) => {
	const classes = useStyles();

	return (
		<Button
			className={classNames(classes.menuButton, { active: open })}
			size="sm"
			variant="link"
			onClick={() => {
				onClick(!open);
			}}
		>
			<span />
		</Button>
	);
};
